import React from 'react'
import { partnerHostStaging, partnerHostLive } from '../../../../../constants'
import { useParams } from 'react-router'
import { Button } from 'react-bootstrap'

const Host = window.location.hostname

const QAStandardsScreen = ({ history }) => {
  const { token, bookingId } = useParams()

  const handleSubmit = async () => {
    try {
      history.push(
        `${
          Host === partnerHostLive || Host === partnerHostStaging
            ? '/'
            : '/partner/'
        }driver/app/details/qaCheck/instructions/${token}/${bookingId}`
      )
    } catch (error) {
      console.log('handleSubmit error', error)
    }
  }

  return (
    <div className='qa-standards-container'>
      <div>
        <img
          className='driver-back-icon-qa mx-50%'
          src='/images/icon-back.png'
          onClick={e => {
            e.preventDefault()
            window.history.back()
          }}
          alt=''
        />
      </div>

      <div className='qa-content-block'>
        <h2 className='qa-heading'>ROLZO quality standards</h2>
        <img
          src='/images/icons/dress-code.png'
          alt='Dress code'
          className='qa-icon'
        />
        <div className='qa-title'>Dress code</div>
        <div className='qa-text'>
          You must wear a dark suit, tie, and formal shoes at all times.
        </div>

        <img
          src='/images/icons/icon-chauffeur-black.png'
          alt='Grooming'
          className='qa-icon'
        />
        <div className='qa-title'>Grooming</div>
        <div className='qa-text'>
          You must be impeccably groomed with a neat, professional appearance.
        </div>

        <img
          src='/images/icons/icon_car.png'
          alt='Vehicle'
          className='qa-icon'
        />
        <div className='qa-title'>Vehicle</div>
        <div className='qa-text'>
          Your vehicle must be clean and maintained to the highest standards
          inside and out.
        </div>

        <img
          src='/images/icons/amenities.png'
          alt='Amenities'
          className='qa-icon'
        />
        <div className='qa-title'>Amenities</div>
        <div className='qa-text'>
          Your vehicle must include water bottles, tissues, mints, and phone
          chargers onboard.
        </div>
      </div>

      <div className='driver-booking-cta-footer'>
        <Button
          className='select-btn select-vehicle mb-2'
          style={{
            width: '100%',
            fontWeight: '900',
            fontSize: '16px',
            textShadow: '0.25px 0 #ffffff',
          }}
          variant='brown'
          onClick={handleSubmit}
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default QAStandardsScreen
